module.exports = __webpack_public_path__ + "media/images/pic/saska/exam-54d9dc632672f00706d218eab0f545db.svg";